export const CREATE_COMPANY = `
mutation createCompany(
  $tenant_id: Int!,
  $input: CreateCompanyInput!,
){
  createCompany(
    tenant_id: $tenant_id
    input: $input
  ){
    __typename
    ... on Company{
      isOptimistic @client
      id
      name
      fantasy_name
      cuit
      phone
      website
      comments
      state
      state_date
      source
      industry
      income
      employees
      zoho_id
      active
      vistage20_id
      province_id
      city
      company_type
      its
      uts
      dts
      company_state {
        id
        name
        restricted
        initial
      }
      company_source {
        id
        name
        vistage20_id
      }
      company_industry {
        id
        name
        active
        vistage20_id
      }
      income_company_incomeToincome {
        id
        name
        active
        vistage20_id
      }
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const UPDATE_COMPANY = `
mutation updateCompany(
  $tenant_id: Int!,
  $input:  UpdateCompanyInput!,
){
  updateCompany(
    tenant_id: $tenant_id
    input: $input
  ){
    __typename
    ... on Company{
      isOptimistic @client
      id
      name
      fantasy_name
      cuit
      phone
      website
      comments
      state
      state_date
      source
      industry
      income
      employees
      zoho_id
      active
      vistage20_id
      province_id
      city
      company_type
      its
      uts
      dts
      company_state {
        id
        name
        restricted
        initial
      }
      company_source {
        id
        name
        vistage20_id
      }
      company_industry {
        id
        name
        active
        vistage20_id
      }
      income_company_incomeToincome {
        id
        name
        active
        vistage20_id
      }
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DELETE_COMPANY = `
mutation deleteCompany(
  $tenant_id: Int!
  $id: Int!
){
  deleteCompany(
    tenant_id: $tenant_id
    id: $id
  ){
    __typename
    ... on Company{
      isOptimistic @client
      id
      name
      fantasy_name
      cuit
      phone
      website
      comments
      state
      state_date
      source
      industry
      income
      employees
      zoho_id
      active
      vistage20_id
      company_type
      its
      uts
      dts
      company_state {
        id
        name
        restricted
        initial
      }
      company_source {
        id
        name
        vistage20_id
      }
      company_industry {
        id
        name
        active
        vistage20_id
      }
      income_company_incomeToincome {
        id
        name
        active
        vistage20_id
      }
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
